import { Component, Input, OnInit, OnDestroy } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-loading-state",
  standalone: true,
  imports: [TranslateModule],
  template: `
    @if (visible) {
    <div class="loading-state"
      [class.loading-state-page]="page"
      [class.loading-state-overlay-copy]="overlay"
      [class.loading-state-inline]="inline"
      [class.loading-state-compact]="compact"
      role="status"
      aria-live="polite">
      <div class="loading-state-mark" aria-hidden="true">
        <span class="loading-state-ball">⚽</span>
      </div>
      <p class="loading-state-title">{{ titleKey | translate }}</p>
      @if (subtitleKey) {
        <p class="loading-state-subtitle">{{ subtitleKey | translate }}</p>
      }
    </div>
    }
  `
})
export class LoadingProgressComponent implements OnInit, OnDestroy {
  @Input() public delayMs = 300;
  @Input() public overlay = false;
  public visible = false;
  private timer: ReturnType<typeof setTimeout>;
  ngOnInit(): void {
    if (this.delayMs <= 0) this.visible = true;
    else this.timer = setTimeout(() => this.visible = true, this.delayMs);
  }
  ngOnDestroy(): void { clearTimeout(this.timer); }

  @Input() public titleKey: string = "common.loadingData";
  @Input() public subtitleKey: string | null = null;
  @Input() public page: boolean = false;
  @Input() public inline: boolean = true;
  @Input() public compact: boolean = false;
}
